import {
  VEHICLES_FETCH_FAIL,
  VEHICLES_FETCH_REQUEST,
  VEHICLES_FETCH_SUCCESS,
} from "../constants/VehicleConstants";
import { getAllVehicles } from "../services/vehicleService";

export const fetchVehicles = () => async (dispatch) => {
  dispatch({ type: VEHICLES_FETCH_REQUEST });

  try {
    const data = await getAllVehicles();
    dispatch({ type: VEHICLES_FETCH_SUCCESS, payload: Array.isArray(data) ? data : [] });
    return Array.isArray(data) ? data : [];
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || "Failed to fetch vehicles.";
    dispatch({ type: VEHICLES_FETCH_FAIL, payload: message });
    throw error;
  }
};
